export type BeforeInstallPromptEvent = Event & {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed"; platform: string }>;
};

type InstallPromptListener = (event: BeforeInstallPromptEvent | null) => void;

let deferredInstallPrompt: BeforeInstallPromptEvent | null = null;
const listeners = new Set<InstallPromptListener>();
let initialized = false;

const notify = () => {
  for (const listener of listeners) listener(deferredInstallPrompt);
};

const setDeferredInstallPrompt = (
  event: BeforeInstallPromptEvent | null,
) => {
  deferredInstallPrompt = event;
  notify();
};

export const initPwaInstallCapture = () => {
  if (initialized || typeof window === "undefined") return;
  initialized = true;

  window.addEventListener("beforeinstallprompt", (event: Event) => {
    event.preventDefault();
    setDeferredInstallPrompt(event as BeforeInstallPromptEvent);
  });

  window.addEventListener("appinstalled", () => {
    setDeferredInstallPrompt(null);
  });
};

export const subscribeInstallPrompt = (
  listener: InstallPromptListener,
) => {
  listeners.add(listener);
  listener(deferredInstallPrompt);

  return () => {
    listeners.delete(listener);
  };
};

export const getInstallPromptEvent = () => deferredInstallPrompt;

export const clearInstallPromptEvent = () => {
  setDeferredInstallPrompt(null);
};
